<template>
  <div class="PaintingDetail">
    <img class="shadow" :src="require(`@/assets/images/${courses[1].imageName}`)" />

    <div class="right-align">
      <div class="TextBox" v-if="!showContact">
        <h1>
          <b>{{ courses[1].title }}</b>
        </h1>
        <p>{{ courses[1].description }}</p>
        <div class="column">
          <b>Startdatum</b>
          <p>{{ courses[1].startDate }}</p>
        </div>
        <div class="column">
          <b>Anmälningsdatum</b>
          <p>{{ courses[1].lastSignUpDate }}</p>
        </div>
        <b>{{ courses[1].price }}kr</b>
      </div>
      <Contact v-if="showContact" />
      <div class="buttonWrapper">
        <button v-if="!showContact" v-on:click="showContact = !showContact">
          Anmäl mig till kursen
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Contact from '@/Components/Contact.vue';

export default {
  setup() {},
  components: {
    Contact,
  },
  data() {
    return {
      showContact: false,
      courses: [
        {
          id: 0,
          imageName: 'garden.jpg',
          title: 'Trädens grönska',
          description: 'En kort beskrivande text som kanske förklarar något',
          price: 599,
          startDate: '3 Mar',
          lastSignUpDate: '1 Mar',
        },
        {
          id: 1,
          imageName: 'studio.jpg',
          title: 'Trädens grönska',
          description: 'En kort beskrivande text som kanske förklarar något',
          price: 599,
          startDate: '7 Jun',
          lastSignUpDate: '5 Jun',
        },
        {
          id: 2,
          imageName: 'mountains-water.jpg',
          title: 'Trädens grönska',
          description: 'En kort beskrivande text som kanske förklarar något',
          price: 599,
          startDate: '11 Jun',
          lastSignUpDate: '9 Jun',
        },
      ],
    };
  },
};
</script>

<style scoped>
.PaintingDetail {
  margin: 3%;
  display: flex;
  justify-content: center;
  align-items: center;
}

img {
  width: 50vw;
  max-width: 500px;
  height: 80vw;
  max-height: 80vh;
  object-fit: cover;
  transition: 0.3s;
  size: 1;
}

.TextBox {
  max-width: 500px;
  min-width: 300px;
  padding: 5%;
}

h1 {
  margin-top: 0;
}

.right-align {
  margin-left: 3%;
}

.column {
  float: left;
  width: 50%;
}
</style>
